<template>
  <v-data-table :headers="headers" :items="studies" :items-per-page="10">
    <!-- site names -->
    <template v-slot:item.sites="{ item }">
      {{ item.sites.map(s => s.name).join(', ') }}
    </template>

    <!-- last patient date -->
    <template v-slot:item.last_date="{ item }">
      {{ usaDate(item.last_date) }}
    </template>

    <!-- archived -->
    <template v-slot:item.archived="{ item }">
      {{ item.archived ? 'Yes' : 'No' }}
    </template>

    <!-- edit button -->
    <template v-slot:item.edit="{ item }">
      <v-btn small class="table-button" :to="`/study/${item.id}`">Open</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';

export default {
  name: 'StudiesTable',
  props: {
    studies: { type: Array, required: true }
  },
  data() {
    return {
      headers: [
        { text: 'Study', value: 'name' },
        { text: 'Sites', value: 'sites' },
        { text: 'Patients', value: 'num_patients' },
        { text: 'Last Patient', value: 'last_date' },
        { text: 'Comment', value: 'comment' },
        { text: 'Archived', value: 'archived' },
        { text: 'Edit', value: 'edit' }
      ]
    };
  },
  methods: {
    usaDate(d) {
      if (!d) {
        return null;
      }
      return moment(d).format('M/D/YYYY');
    }
  }
};
</script>

<style scoped>
.table-button {
  padding: 0px;
  margin: 0px;
  min-width: 40px;
}
</style>
